// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_1_F9_","selectWrapper":"_3c-DQ"};